@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import (reference) '../../../style.module.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

@fontSize: 13px;

.checklist-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: @space-0 @space-8;
}

.tag-pill {
  margin-right: @space-4;
}

.single-pill-wrapper {
  align-items: center;
  display: flex;
}

.pill {
  margin-left: @space-8;
  max-width: calc(100% - 25px);
}

.order-tag-dropdown-toggler {
  width: 100%;
  padding: @space-4;
  height: 32px;
}

.order-tag-dropdown-toggler svg {
  fill: @product-page--dropdown-toggler--icon-color;
}

.order-tag-dropdown {
  width: 100%;
  display: flex;
}

.order-tag-dropdown .order-tag-dropdown-toggler {
  background: @product-page--dropdown-toggler--background-color;
}

.order-tag-dropdown .order-tag-dropdown-toggler :hover {
  background: @product-page--dropdown-toggler--hover--background-color;
}

/* === Tab wrapper === */

.general-tab {
  padding: @space-0 @space-16 @space-16;
}

/* === Main content card (Overview + Attributes) === */

.content-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
}

/* === Toggle card (bordered container for each additional section) === */

.toggle-card {
  background-color: var(--white);
  border: 1px solid var(--default--border-color--10);
  border-radius: @space-4;
  padding: @space-12 @space-16;
  margin-top: @space-12;
}

/* Hide the divider rendered by ShipStationFulfillmentSettings — redundant inside toggle-card */
.toggle-card--fulfillment > div > div:first-child {
  display: none;
}

/* === Section layout === */

.section {
  padding: @space-16;
}

/* === Overview section === */

.product-type-row {
  margin-bottom: @space-8;
}

.name-sku-row {
  align-items: flex-start;
}

.name-field {
  flex: 2;
}

.sku-field {
  flex: 1;
}

.rounded-input input {
  border-radius: @space-4;
}

.override-row {
  padding: @space-8 @space-0;
}

.toggles-row {
  padding-top: @space-8;
  align-items: flex-start;
}

.toggle-column {
  flex: 1;
}

/* === Attributes section === */

.attributes-grid {
  display: grid;
  grid-template-columns: 5fr 6fr;
  column-gap: @space-24;
  padding-top: @space-8;
  padding-bottom: @space-24;
}

// Flex chain so the Description textarea bottom aligns with Reporting Category.
// The InlineMessage (character count) is positioned absolutely so it hangs below
// the grid row without affecting height. min-height:0 on every flex item lets the
// grid row be sized by the left column only.
.attributes-right {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

// FloatTextAreaWithCharacterCount renders: <div> <FloatTextArea/> <InlineMessage/> </div>
.attributes-right > div:last-child {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 0;
}

// FloatTextArea wrapper — flex:1 gives it the remaining height.
.attributes-right > div:last-child > div:first-child {
  flex: 1;
  min-height: 0;
}

// InlineMessage (character count) — taken out of flex flow so the textarea
// bottom aligns with the left column's Reporting Category bottom edge.
.attributes-right > div:last-child > div:last-child:not(:first-child) {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(100%);
}

/* === Image block (within Attributes section) === */

.image-block {
  padding-top: @space-8;
}

.image-url-input {
  width: calc((100% - @space-16) * 5 / 11);
}

.helper {
  padding-top: @space-4;
  color: var(--gray-637381);
}

/* === Shared === */

.reporting-category-dropdown select {
  padding: @space-4;
}

.label {
  padding: @space-8 @space-0 @space-4;
  font-weight: 500;
}

/* === Variants (unchanged) === */

.variants {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: @space-0 @space-20;
}

.variants-title {
  padding-bottom: @space-8;
  border-bottom: 1px solid @product-page--variants-title--border-color;
}

.variants-wrapper {
  padding: @space-20 @space-0;
}

.variants-header,
.variants-item {
  display: grid;
  grid-template-columns: 200px 300px 75px 200px;
  font-size: @fontSize;
  border: 1px solid @product-page--variants--border-color;
  border-bottom: 0;
}

.variants-header > div,
.variants-item > div {
  padding: @space-4;
}

.variants-item {
  border-right: 1px solid @product-page--variants--border-color;
  border-left: 1px solid @product-page--variants--border-color;
}

.variants-item:last-child {
  border-bottom: 1px solid @product-page--variants--border-color;
}

.variants-item.centered {
  justify-content: center;
}

.variants-header,
.variants-footer {
  background-color: @product-page--variants--background-color;
  font-weight: 500;
}

.variants-footer {
  display: grid;
  grid-template-columns: 200px 300px auto;
  border: 1px solid @product-page--variants--border-color;
}

.variants-footer > div {
  padding: @space-4;
}

.variants-footer.variant-loading {
  grid-template-columns: 100%;
}

.variants-footer .variant-loading-indicator {
  height: 36px;
  width: 36px;
  margin: auto;
}

.variant-active {
  height: 16px;
  width: 16px;
  fill: @product-page--variants--active--fill-color;
}

.add-variant {
  text-align: center;
}

.save-in-place {
  padding: @space-0 @space-20;
}

.sip-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sip-content > button {
  margin-top: @space-20;
}

.sip-message {
  margin-top: @space-20;
}

.sip-loading {
  height: 44px;
  width: 44px;
  margin: @space-8 auto;
}

.auto-complete-dropdown {
  min-width: 300px;
  max-width: 300px;
  max-height: 160px;
  overflow: auto;
}

.product-sku {
  color: @product-page--sku--text-color;
  font-weight: 500;
  margin-top: @space-8;
}

.modal-body {
  width: 400px;
  padding: @space-20;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.inherited-pill {
  margin: 6px 5px 6px 0;
}

.tags-list.empty {
  padding: @space-8 @space-0;
  color: @product-page--tags-list--empty--text-color;
}
